import { render, staticRenderFns } from "./CowScreening.vue?vue&type=template&id=245e7b1f&scoped=true&"
import script from "./CowScreening.vue?vue&type=script&lang=js&"
export * from "./CowScreening.vue?vue&type=script&lang=js&"
import style0 from "./CowScreening.vue?vue&type=style&index=0&id=245e7b1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245e7b1f",
  null
  
)

export default component.exports